<template>
	<div class="book h-100">
		<div class="d-flex flex-column justify-content-between h-100">
			<div>
				<div class="book-ratio" :style="{'backgroundImage':'url('+book_data.photo+')'}" v-on:click="$emit('detail', book_data.id)"></div>
				<a :href="'#!'"
					v-on:click="$emit('detail', book_data.id)"
					class="book-title"
					style="-webkit-box-orient: vertical; font-family: 'Roboto', sans-serif;"
					:style="{ 'color': book_data.total_stock == 0 ? '#AAAAAA' : '#91272b', }"
					v-html="book_data.title"></a>
				<div class="book-author">
					<p>{{ by_label }} </p>
					<a href="#!" class="text-wrap" v-on:click="$emit('author_link', book_data.author)">{{ book_data.author }}</a>
				</div>
			</div>

			<div>
				<p class="price-discount" v-if="book_data.discount != 0">Rp. {{ book_data.price.toLocaleString('id-ID') }}</p>
				<p class="price" :style="{'color': book_data.total_stock == 0 ? '#AAAAAA' : '#91272b', }">{{ book_data.disc_price > 0 ? 'Rp. ' + book_data.disc_price.toLocaleString('id-ID') : coming_soon_label }}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
		'book_data', 'coming_soon_label', 'by_label',
		],
		mounted() {
		},
		methods:{

		}
	}
</script>
